/* ============================================================
   tio-faq-express.js — Acordeon de "Dudas frecuentes"
   13-sep-2026

   QUE HACE: abre y cierra las preguntas con animacion, y cuando se abre
   una se cierra la que estuviera abierta (acordeon de una sola apertura,
   igual que la referencia).

   SIN ESTE ARCHIVO TODO SIGUE FUNCIONANDO. Las preguntas son <details>
   con el atributo `name`, y el navegador ya hace solo que abrir una
   cierre las otras. Lo unico que aporta este archivo es la animacion.

   POR QUE SE QUITA EL `name` AL ARRANCAR. Con `name` puesto, en cuanto
   este script abre una pregunta el navegador cierra la anterior DE GOLPE,
   sin darle tiempo a animar. Se retira para que la exclusividad la
   maneje este archivo y el cierre de la anterior tambien sea suave.

   MISMO PATRON QUE tio-incluye.js, que ya se probo en produccion:
     · toda clase temporal se limpia tambien por setTimeout, que corre
       aunque el navegador no este pintando (pestaña en segundo plano,
       cambio de app). Sin eso un requestAnimationFrame que no llega deja
       la pregunta trabada.
     · un contador de turno invalida el cierre de una pregunta si el
       cliente la vuelve a abrir antes de que termine.

   Listeners DELEGADOS en document (doctrina 8.1): el Quick View se
   inyecta y se destruye; un handler por elemento moriria con el nodo.
   ============================================================ */
(function () {
  'use strict';

  if (window.__tioFaqe) return;
  window.__tioFaqe = true;

  function duracion(caja) {
    var v = (getComputedStyle(caja).transitionDuration || '0s').split(',')[0].trim();
    var n = parseFloat(v) || 0;
    return v.slice(-2) === 'ms' ? n : n * 1000;
  }

  function limpiar(det) {
    det.classList.remove('is-abriendo');
    det.classList.remove('is-cerrando');
  }

  function abrir(det) {
    var caja = det.querySelector('.faqe__wrap');
    det._tioTurno = (det._tioTurno || 0) + 1;
    limpiar(det);
    det.open = true;
    if (!caja) return;
    det.classList.add('is-abriendo');
    void caja.offsetHeight;   /* fuerza el reflow: sin esto no hay transicion */
    var soltar = function () { det.classList.remove('is-abriendo'); };
    if (window.requestAnimationFrame) requestAnimationFrame(soltar);
    setTimeout(soltar, 80);
  }

  function cerrar(det) {
    var caja = det.querySelector('.faqe__wrap');
    var mi = det._tioTurno = (det._tioTurno || 0) + 1;
    limpiar(det);
    if (!caja) { det.open = false; return; }

    var ms = duracion(caja);
    det.classList.add('is-cerrando');
    if (ms < 20) { det.classList.remove('is-cerrando'); det.open = false; return; }

    var hecho = false;
    var terminar = function (e) {
      if (e && e.propertyName !== 'grid-template-rows') return;
      if (hecho) return;
      hecho = true;
      caja.removeEventListener('transitionend', terminar);
      if (mi !== det._tioTurno) return;   /* lo reabrieron: este cierre ya no manda */
      det.classList.remove('is-cerrando');
      det.open = false;
    };
    caja.addEventListener('transitionend', terminar);
    setTimeout(terminar, ms + 120);
  }

  /* Retira el `name` de todos los grupos presentes y de los que lleguen
     despues (el Quick View). Se hace al primer clic sobre cada bloque, que
     es cuando de verdad importa, y asi no hace falta observar el DOM. */
  function soltarNombres(bloque) {
    if (bloque._tioSinNombre) return;
    bloque._tioSinNombre = true;
    var dets = bloque.querySelectorAll('details.faqe__item[name]');
    for (var i = 0; i < dets.length; i++) dets[i].removeAttribute('name');
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest ? e.target.closest('.faqe__q') : null;
    if (!q) return;
    var det = q.parentNode;
    if (!det || det.tagName !== 'DETAILS') return;
    var bloque = det.closest('[data-tio-faqe]');
    if (!bloque) return;

    e.preventDefault();
    soltarNombres(bloque);

    var estabaAbierta = det.open && !det.classList.contains('is-cerrando');

    /* Acordeon de una sola apertura: se cierran las demas del MISMO
       bloque. Se acota al bloque porque la ficha y el Quick View pueden
       estar abiertos a la vez y no deben cerrarse entre si. */
    var hermanas = bloque.querySelectorAll('details.faqe__item');
    for (var i = 0; i < hermanas.length; i++) {
      if (hermanas[i] !== det && hermanas[i].open && !hermanas[i].classList.contains('is-cerrando')) {
        cerrar(hermanas[i]);
      }
    }

    if (estabaAbierta) cerrar(det);
    else abrir(det);
  });
})();
